/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const MegaphoneStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M7 7H4.4C3.07452 7 2 8.07452 2 9.4V12.6C2 13.9255 3.07452 15 4.4 15H7M7 7L18 3V19L7 15M7 7V15M7 21L4 15M18 7C20.3704 7.33333 22 8.66667 22 11C22 13.3333 20.3704 14.6667 18 15V7Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { MegaphoneStrokeIcon };
